import {Props_RecruitmentProcess} from './RecruitmentProcess.props'
import {CompileMarkdown} from "../../../../Shared/AttraxTs/React/ReactSnippetMDCompiler";

const SnippetRecruitmentProcess = (props: Props_RecruitmentProcess) => {
    const {repeatable_card,heading} = props;
    const baseClass = "recruitment-process";
    
    return (
        <section className={`${baseClass}`}>
            <div className={`${baseClass}__container`}>
                {heading?.content?.value &&
                    <h2 className={`${baseClass}__heading ${heading.visibility?.value === false ? 'accessible-heading' : ''}`}>
                        {heading.content.value}
                    </h2>
                }
                <div className={`${baseClass}__cards`}>
                    {repeatable_card?.map((card, index) => (
                        <a className={`${baseClass}__card-link`} key={index} href={card.linkHref?.value} aria-label={card.linkAriaLabel?.value}>
                            <div className={`${baseClass}__card`}>
                                <div className={`${baseClass}__number-container`}>
                                    <div className={`${baseClass}__number`}>
                                        <p>{index + 1}</p>
                                    </div>
                                </div>
                                <div className={`${baseClass}__content`}>
                                    {card.heading?.value &&
                                        <h3 className={`${baseClass}__card-heading`}>
                                            {card.heading.value}
                                        </h3>
                                    }
                                    {card.content?.value &&
                                        <div className={`${baseClass}__card-content`}>
                                            {CompileMarkdown(card.content.value)}
                                        </div>
                                    }
                                </div>
                            </div>
                        </a>
                    ))}
                </div>
            </div>
        </section>
    )
}

export default SnippetRecruitmentProcess;